import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { YellowButton } from 'components/Buttons';

export const CardListItem = styled.li`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.beige};
  padding: 12px;

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.beige};
  }
`;

export const CardContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  row-gap: 8px;
  align-items: center;
`;

export const Label = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.night};
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  line-height: 11px;
`;

export const Value = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.night};
  font-size: 14px;
  line-height: 14px;
`;

export const DetailsLink = styled(Link)`
  text-transform: uppercase;
  text-decoration: underline;
  font-size: 12px;
`;

export const PayButton = styled(YellowButton)`
  margin-left: 8px;
  padding: 8px 24px;

  font-size: 14px;
  text-transform: uppercase;
`;
